import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from '../assets/img/logo.png';
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { collection, getDocs, query } from "firebase/firestore";
import { MdOutlineDarkMode } from "react-icons/md";
import { db } from "../firebase";


export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  const [myData, setMyData] = useState([]);

    async function fetchData() {
        try {
            const projectRef = collection(db, 'profile');
            const q = query(projectRef);
            const querySnap = await getDocs(q);
            let projects = [];
            querySnap.forEach((doc) => {
                projects.push({
                    id: doc.id,
                    data: doc.data()
                });
            });
            setMyData(projects);
            //console.log(projects);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
      fetchData();
    }, []);

  useEffect(() => {
    
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const containerStyle = windowWidth > 1200 ? { marginLeft: "100px", marginRight: "100px",marginTop:"10px" } : {marginTop:"10px" };

  return (
      <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
        <Container fluid style={containerStyle}>
          <Navbar.Brand href="/"  className="navbar-logo">
            <img src={logo} alt="Logo" style={{width:"200px"}}/>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">

              <Nav.Link href="/#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
              <Nav.Link href="/#qualification" className={activeLink === 'qualification' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('qualification')}>Qualification</Nav.Link>
              <Nav.Link href="/#project" className={activeLink === 'project' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('project')}>Projects</Nav.Link>
              <Nav.Link href="/#awards" className={activeLink === 'awards' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('awards')}>Awards</Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href={myData[0]?.data.githubLink} target="_blank"  
                style={{backgroundColor:"white",transition: 'background-color 0.3s '}}  
                onMouseEnter={(e) => { 
                  e.currentTarget.style.backgroundColor = 'black'; 
                  e.currentTarget.querySelector('svg').style.color = 'white';
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.backgroundColor = 'white'; 
                   e.currentTarget.querySelector('svg').style.color = 'black';
                 }}><FaGithub style={{ fontSize: '2rem', color: 'black' }} /></a>
                <a href={myData[0]?.data.linkedinLink} target="_blank"  
                style={{backgroundColor:"white",transition: 'background-color 0.3s ease-in-out'}}  
                onMouseEnter={(e) => { 
                  e.currentTarget.style.backgroundColor = 'black'; 
                  e.currentTarget.querySelector('svg').style.color = 'white';
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.backgroundColor = 'white'; 
                   e.currentTarget.querySelector('svg').style.color = 'black';
                 }}><FaLinkedin style={{ fontSize: '2rem', color: 'black' }} /></a>
                <a href={myData[0]?.data.facebookLink}target="_blank"  
                style={{backgroundColor:"white",transition: 'background-color 0.3s ease-in-out'}}  
                onMouseEnter={(e) => { 
                  e.currentTarget.style.backgroundColor = 'black'; 
                  e.currentTarget.querySelector('svg').style.color = 'white';
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.backgroundColor = 'white'; 
                   e.currentTarget.querySelector('svg').style.color = 'black';
                 }}><FaFacebook style={{ fontSize: '2rem', color: 'black' }} /></a>
                <a href={myData[0]?.data.whatsappNo} target="_blank"  
                style={{backgroundColor:"white",transition: 'background-color 0.3s ease-in-out'}}  
                onMouseEnter={(e) => { 
                  e.currentTarget.style.backgroundColor = 'black'; 
                  e.currentTarget.querySelector('svg').style.color = 'white';
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.backgroundColor = 'white'; 
                   e.currentTarget.querySelector('svg').style.color = 'black';
                 }}><IoLogoWhatsapp style={{ fontSize: '2rem', color: 'black' }} /></a>


                {/* <a href={myData[0]?.data.linkedinLink} target="_blank"><FaLinkedin style={{ fontSize: '2rem', color: 'white' }}/></a> */}
                {/* <a href={myData[0]?.data.facebookLink} target="_blank"><FaFacebook style={{ fontSize: '2rem', color: 'white' }}/></a> */}
                {/* <a href={myData[0]?.data.whatsappNo} target="_blank"><FaWhatsapp style={{ fontSize: '2rem', color: 'white' }}/></a> */}
                
              </div>
                
              
              <div class="cvContactBtn" style={{display:"flex"}}>
                <a href={myData[0]?.data.cvLink} target="_blank">
                  <button className="vvd btns btns1" ><span>CV</span></button>
                </a>
                <a href="#connect">
                  <button className="vvd btns btns2" style={{padding:"7px",paddingLeft:"20px",paddingRight:"20px"}}><span>Contact<br/> Me</span></button>
                </a>
              </div>
            </span>
            
              

            
          </Navbar.Collapse>
        </Container>
      </Navbar>
  )
}
